import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-version',
	templateUrl: './version.component.html',
	styleUrl: './version.component.less'
})
export class VersionComponent {
	version: string = environment.version;
	today = new Date();

	constructor() { }

	ngOnInit(): void {
	}
}
